<template>
  <div>
    <!-- Navbar always visible -->
    <NavBar />

    <!-- Main Content Area -->
    <div class="container mt-4">
      <LoginComponent />
    </div>
  </div>
</template>

<script>
import NavBar from './components/NavBar.vue';
import LoginComponent from './components/LoginComponent.vue';

export default {
  components: {
    NavBar,
    LoginComponent
  }
};
</script>

<style>
body {
  font-family: Arial, sans-serif;
  background-color: #f4f4f4;
  margin: 0;
}
</style>
